(function () {

  var interval = 167;

  var filterButtonSelector = 'a.cloud-search-page-controls__filters-link';

  var filtersContainer = document.querySelector('.cloudsearch-filters-container');

  function cloneFiltersBar() {

    if (
      window.innerWidth >= 800 &&
      document.querySelector('.cloudsearch-filters-container') &&
      document.querySelector('.cloudsearch-filters-container').querySelector(filterButtonSelector) &&
      document.querySelector('.sticky_nav') &&
      !document.querySelector('.sticky_nav').querySelector('.cloudsearch-filters-container')
    ) {
      var filtersClone = document.querySelector('.container.cloudsearch-filters-container').cloneNode(true);
      filtersClone.querySelector('.cloud-search-page-controls').style.display = 'inline-flex';
      
      document.querySelector('.sticky_nav').appendChild(filtersClone);

      if(document.querySelector('#shopify-section-collection-overcube-cloudsearch > div > div > div.container.cloudsearch-filters-container') !== null){
        document.querySelector('#shopify-section-collection-overcube-cloudsearch > div > div > div.container.cloudsearch-filters-container').style.display = '';
      }

      var cloneButton = filtersClone.querySelector('a.cloud-search-page-controls__filters-link');

      cloneButton &&
        (cloneButton.onclick = function (event) {
          event.preventDefault();

          document.querySelector(`.wrapper ${'#cloud_search_filters_root > div > div > a'}`).click();
          return true;
        }) &&
        (Array.from(filtersClone.querySelectorAll('.cloud-search-applied-filter__clear')).map(function (clearBtn, index) {
          clearBtn.onclick = function (event) {
            event.preventDefault();
            filtersContainer.querySelectorAll('.cloud-search-applied-filter__clear')[index].click();
          }
        }));

      clearInterval(cloneInterval);
    }
  }

  function toggleFiltersContainer() {
    if (
      window.innerWidth >= 800 &&
      window.scrollY >= 400
    ) {
      window.requestAnimationFrame(function () {

        if(document.querySelector('.container.cloudsearch-filters-container')){
          document.querySelector('.container.cloudsearch-filters-container').style.display = 'inline-flex';
        } 
        if(document.querySelector('body > div.main_nav_wrapper.sticky_nav.sticky_nav--stick > div.container.cloudsearch-filters-container')){
          document.querySelector('body > div.main_nav_wrapper.sticky_nav.sticky_nav--stick > div.container.cloudsearch-filters-container').style.width = '100%';
        }
      });
    } else {
      window.requestAnimationFrame(function () {

        if(document.querySelector('.container.cloudsearch-filters-container')){
          document.querySelector('.container.cloudsearch-filters-container').style.display = '';
        }
      });
    }
  }

  function adjustToBanner() {
    var bannerEl = document.querySelector('#header .promo_banner');

    bannerEl.onclick = adjustToBanner;
    setTimeout(function () {
      if(document.querySelector('.container.cloudsearch-filters-container')){
        bannerEl.offsetHeight === 30 ? document.querySelector('.container.cloudsearch-filters-container').classList.add('adjust-to-promo') : document.querySelector('.container.cloudsearch-filters-container').classList.remove('adjust-to-promo');
      }
   }, interval);

  }

  function moveFilter() {
    var x = window.matchMedia("(max-width: 767px)")
    if(x.matches){
      document.querySelector('.container.cloudsearch-filters-container').style.width = '50%';
    } 
  };

  function hideFilterBehindNav() {
    if ($('.sticky_nav').hasClass('sticky_nav--stick')) {
      document.querySelectorAll('.container.cloudsearch-filters-container')[1].style.display = 'none';
      document.querySelectorAll('.container.cloudsearch-filters-container')[0].style.display = 'inline-flex';
    } else if($('.sticky_nav').hasClass('sticky_nav--unstick')){
      document.querySelectorAll('.container.cloudsearch-filters-container')[1].style.display = 'inline-flex';
    }
  }

  function sortChange(){
    if( document.querySelectorAll('#sort-by')[0] !== undefined ) {
      //document.querySelectorAll("#sort-by")[0].setAttribute("data-number", "0");
      document.querySelectorAll('#sort-by')[0].addEventListener('change', function(e){
        document.querySelectorAll('#sort-by')[1].value = document.querySelectorAll('#sort-by')[0].value;
      });
    }

    if( document.querySelectorAll('#sort-by')[1] !== undefined ) {
      //document.querySelectorAll("#sort-by")[1].setAttribute("data-number", "1");
      document.querySelectorAll('#sort-by')[1].addEventListener('change', function(e){
        document.querySelectorAll('#sort-by')[0].value = document.querySelectorAll('#sort-by')[1].value;
      });
    }
  }

  var cloneInterval = setInterval(cloneFiltersBar, interval);

  setInterval(toggleFiltersContainer, interval / 2);

  window.addEventListener('load', adjustToBanner);

  window.addEventListener('load', moveFilter);

  setInterval(hideFilterBehindNav, interval / 2);

  setInterval(sortChange, interval);

})();
